// Pure renderer for the theme-toggle button. The click handler is
// wired by src/lib/theme.ts:setupThemeToggle() which finds any
// [data-theme-toggle] element in the DOM and binds.

export function renderThemeToggle(): string {
  return `
    <button type="button"
            class="theme-toggle"
            data-theme-toggle
            aria-label="Switch theme">
      <svg class="theme-toggle-sun" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M10 3a1 1 0 011 1v1a1 1 0 11-2 0V4a1 1 0 011-1zm5.66 2.34a1 1 0 010 1.41l-.71.71a1 1 0 11-1.41-1.41l.71-.71a1 1 0 011.41 0zM17 10a1 1 0 110 2h-1a1 1 0 110-2h1zm-2.34 5.66a1 1 0 01-1.41 0l-.71-.71a1 1 0 011.41-1.41l.71.71a1 1 0 010 1.41zM10 15a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zm-5.66-.34a1 1 0 011.41 0l.71.71a1 1 0 11-1.41 1.41l-.71-.71a1 1 0 010-1.41zM3 10a1 1 0 110-2h1a1 1 0 110 2H3zm2.34-5.66a1 1 0 010 1.41l-.71.71A1 1 0 113.22 5.05l.71-.71a1 1 0 011.41 0zM10 7a3 3 0 100 6 3 3 0 000-6z"/>
      </svg>
      <svg class="theme-toggle-moon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"/>
      </svg>
    </button>
  `;
}
